'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import DashboardContent from './components/DashboardContent';

export default function DashboardPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur', 'Broker']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/dashboard">
        <DashboardContent />
      </AppLayout>
    </RouteGuard>
  );
}